import React, {ReactElement} from 'react';
import IESunsetLayout from '../../../Components/Warning/IESunsetLayout';

const IESunset = (): ReactElement => <IESunsetLayout/>;

export {IESunset as TestableIESunset};
export default IESunset;
